import { thumbnailDemo } from '../../../demos/thumbnails.js';
import { html } from '@design.estate/dees-element';

export const demo = () => thumbnailDemo('Audio thumbnails', 'A clear preview, with the details close at hand. Open a file to take a closer look.', html`

  <div class="demo-container">
    <div class="demo-section">
      <h3>Audio Tiles</h3>
      <div class="tile-row">
        <dees-thumbnail-audio
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
          title="SoundHelix Song 1"
          artist="T. Schuerger"
          label="soundhelix-1.mp3"
        ></dees-thumbnail-audio>

        <dees-thumbnail-audio
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3"
          title="SoundHelix Song 2"
          artist="T. Schuerger"
          label="soundhelix-2.mp3"
        ></dees-thumbnail-audio>

        <dees-thumbnail-audio
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3"
          title="SoundHelix Song 3"
          label="soundhelix-3.mp3"
        ></dees-thumbnail-audio>
      </div>
    </div>

    <div class="demo-section">
      <h3>Size Variants</h3>
      <div class="tile-row">
        <dees-thumbnail-audio
          size="small"
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
          title="Small"
          label="small.mp3"
        ></dees-thumbnail-audio>

        <dees-thumbnail-audio
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
          title="Default"
          label="default.mp3"
        ></dees-thumbnail-audio>

        <dees-thumbnail-audio
          size="large"
          src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
          title="Large"
          label="large.mp3"
        ></dees-thumbnail-audio>
      </div>
    </div>
  </div>
`);
